import styled from "styled-components";
import { Colors } from "../../../styles/colors";

export const Container = styled.div`
	background-color: #ffffff;
	border-radius: 24px;
	box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
	position: relative;
	width: 100%;
	max-width: 560px;
	padding: 2.5rem 2.5rem 1.5rem;
	display: flex;
	flex-direction: column;
	align-items: center;

	.close {
		position: absolute;
		right: 1.5rem;
		top: 1.5rem;
		cursor: pointer;
		width: 1.5rem;
		height: 1.5rem;
	}

	.illustration {
		margin-top: 0.5rem;
		margin-bottom: 0.25rem;
	}

	.title {
		font-family: "NotoSans-Regular";
		font-weight: 700;
		font-size: 1.5rem;
		line-height: 1.75rem;
		text-align: center;
		color: ${Colors.primary_blue_k_main};
		margin: 1.25rem 0 0;
		max-width: 420px;

		.titleDesktop {
			display: block;
		}

		.titleMobile {
			display: none;
		}

		@media (max-width: 767px) {
			font-size: 1.25rem;
			line-height: 1.5rem;

			.titleDesktop {
				display: none;
			}

			.titleMobile {
				display: block;
			}
		}
	}

	.subtitle {
		font-family: "NotoSans-Regular";
		font-weight: 500;
		font-size: 1.0625rem;
		line-height: 1.625rem;
		text-align: center;
		color: ${Colors.primary_blue_k_main};
		margin: 1.25rem 0 0;
		max-width: 82%;
	}

	.checkboxRow {
		display: flex;
		align-items: flex-start;
		gap: 0.5rem;
		margin-top: 1.875rem;
		width: 100%;
		max-width: 82%;
		cursor: pointer;
		border: none;
		background: transparent;
		padding: 0;
		text-align: left;
	}

	.checkbox {
		flex-shrink: 0;
		width: 22px;
		height: 22px;
		border-radius: 3px;
		border: 1px solid ${Colors.neutral_grey_k_70};
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: ${Colors.white};
		margin-top: 2px;

		&.checked {
			border-color: ${Colors.secondary_green_k_dark_2};
			background-color: ${Colors.secondary_green_k_dark_2};
		}
	}

	.checkboxLabel {
		font-family: "NotoSans-Regular";
		font-size: 1.0625rem;
		font-weight: 700;
		color: ${Colors.primary_blue_k_main};
		line-height: 1.625rem;
		margin: 0;
	}

	.termsLink {
		color: ${Colors.secondary_green_k_dark_2};
		text-decoration: underline;
		cursor: pointer;
		background: none;
		border: none;
		padding: 0;
		font: inherit;
		font-weight: 700;

		&:hover {
			opacity: 0.85;
		}
	}
`;

export const ContainerButtons = styled.div`
	width: 100%;
	max-width: 82%;
	margin-top: 2rem;
`;

export const ButtonConfirmar = styled.button<{ $isEnabled: boolean }>`
	width: 100%;
	padding: 0.875rem 1.5rem;
	border: none;
	border-radius: 12px;
	background-color: ${({ $isEnabled }) =>
		$isEnabled ? Colors.primary_blue_k_main : Colors.neutral_grey_k_60};
	color: #fafafa;
	font-family: "Kanit-Regular";
	font-weight: 600;
	font-size: 1rem;
	line-height: 1.5rem;
	text-align: center;
	cursor: ${({ $isEnabled }) => ($isEnabled ? "pointer" : "not-allowed")};
	transition: background-color 0.3s ease;

	&:hover:not(:disabled) {
		background-color: ${Colors.primary_blue_k_dark_2};
	}

	&:disabled {
		opacity: 1;
	}
`;

export const TextConfirmar = styled.span`
	display: block;
`;
